{% block jga_revocation_blocked_message %}
    <div class="jga-revocation-blocked-message">
        <div class="jga-revocation-blocked-message__header">
            <label v-if="label" class="jga-revocation-blocked-message__label">{{ label }}</label>
            <sw-help-text v-if="helpText" :text="helpText"></sw-help-text>
        </div>

        <sw-single-select
            class="jga-revocation-blocked-message__locale-select"
            :value="activeLocale"
            :options="languageOptions"
            :label="$tc('jga-revocation.blockedMessage.language')"
            show-clearable-button="false"
            @update:value="switchLocale($event)"
        ></sw-single-select>

        <div class="jga-revocation-blocked-message__editor">
            <sw-text-editor
                :value="currentText"
                :sanitize-input="false"
                @input="onTextChange($event)"
                @update:value="onTextChange($event)"
            ></sw-text-editor>
        </div>
    </div>
{% endblock %}
